import React, { useContext, useState, useRef, useEffect } from "react";
import { isEmpty } from "lodash";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import "../../../styles/containers/CommunicationContainer.scss";
import { Formik, Field } from "formik";
import {
  ManageCommunicationLayout,
  FieldInput,
  QuillEditor,
  FieldTextarea,
  SliderPanel,
  FormControlSearch,
  EmailLayout,
  LoaderWrapper,
  AddToolTip,
  WarningModal,
  FormLeaveGuard,
} from "../../../components";
import {
  manageCommunicationStore,
  setManageCommunicationToastInfo,
} from "../../../contexts";
import { Link } from "react-router-dom";
import {
  manageCommunicationFormNames,
  formFields,
  MANAGE_COMMUNICATION_ROUTES,
  FLOW_TYPES,
  getPathWithParam,
  getAdvancedPathWithParam,
} from "../../../utils";
import {
  addEmailLayout,
  deleteEmailLayout,
  getEmailDataById,
  getEmailLayout,
} from "../../../services";
import InfiniteScroll from "react-infinite-scroller";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";

const NewEmailLayoutContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageCommunicationStore);
  const [data, setData] = useState("");
  const Dirty = useRef(false);
  const [showEditor, setShowEditor] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [cannotBeDeleted, setCannotBeDeleted] = useState(false);
  const [direction, setDirection] = useState("row");
  const [selectedImage, setSelectedImage] = useState();
  const [filteredImage, setFilteredImage] = useState([]);
  const [images, setImages] = useState([]);
  const [showLayout, setShowLayout] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const { flow, layoutId } = useRouterParams();
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = manageCommunicationFormNames.EMAIL_LAYOUT_INFO;
  const fields = formFields[formName];
  const intLayoutId = parseInt(layoutId, 10);
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const prevId = useRef(0);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const append = useRef(false);
  const numberOfRecordsToFetch = 20;
  const [request, setRequest] = useState({
    from: 0,
    offset: numberOfRecordsToFetch,
  });
  const customBreadCrumbs = [
    {
      label: "E-Mail Layout",
      link: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO,
    },
  ];
  const pageName = useRef("New E-Mail Layout");
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const initialValues = {};
  const buttons = [
    {
      // link: getPathWithParam({
      //   path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
      // }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE, FLOW_TYPES.EDIT],
      onClick: () => showWarningToast(),
    },
    {
      label: "Next",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD],
      //onClick: () => setShowEditor(true),
      onClick: () => setShowLayout(true),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
      onClick: () => {
        setIsSubmit(!isSubmit);
      },
    },
    {
      label: "Edit",
      variant: "link",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO,
            pathParam: [FLOW_TYPES.SAVE, intLayoutId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => showDeleteToast(),
    },
  ];
  const buttons1 = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setShowEditor(false);
        //setSelectedImage(null);
        setFilteredImage(images);
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      onClick: () => {
        setIsSubmit(!isSubmit);
        setShowEditor(false);
      },
    },
  ];
  const buttons3 = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setShowLayout(false);
        setSelectedImage();
        setFilteredImage(images);
      },
    },
    {
      label: "Proceed",
      variant: "primary",
      type: "button",
      onClick: () => {
        openPage(selectedImage.id);
      },
      disabled: selectedImage == null ? true : false,
    },
  ];
  useDeepEffect(() => {
    getEmailLayout({ search: "", ...request }).then((response) => {
      setLoading(false);
      if (response?.length < numberOfRecordsToFetch)
        setStopInfiniteScroll(true);
      if (append.current) {
        setImages((prev) => [...prev, ...response]);
        setFilteredImage((prev) => [...prev, ...response]);
      } else {
        setImages(response);
        setFilteredImage(response);
      }
    });
    if (!intLayoutId) return;
    setLoading(true);
    pageName.current = "E-Mail Layout";
    getEmailDataById(intLayoutId)
      .then((response) => {
        setLoading(false);
        setFormValues(response);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [request]);

  //Since toast message at layout is blocked we are using a custom one
  const showWarningToast = () => {
    if (isEdit || !Dirty.current) {
      history.push(
        getAdvancedPathWithParam({
          path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
        })
      );
      return;
    }
    setModalVisible(true);
  };
  const showDeleteToast = () => {
    // if (isEdit || !Dirty.current) {
    //   history.push(
    //     getAdvancedPathWithParam({
    //       path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
    //     })
    //   );
    //   return;
    // }
    setIsDelete(true);
  };
  const onDeleteClick = () => {
    setLoading(true);
    deleteEmailLayout(intLayoutId).then((response) => {
      if (response) {
        setLoading(false);
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
          })
        );
        dispatch(
          setManageCommunicationToastInfo({
            showToast: true,
            toastMessage: `${formValues.layoutName} Layout deleted successfully`,
          })
        );
      } else {
        setIsDelete(false);
        setCannotBeDeleted(true);
        setLoading(false);
        // dispatch(
        //   setManageCommunicationToastInfo({
        //     showToast:true,
        //     toastMessage:"Email Layout cannot be deleted because it is associatted to a communication"
        //   })
        // )
      }
    });
  };

  const onFormSubmit = (values, { setFieldTouched, setFieldError }) => {
    setLoading(true);
    addEmailLayout(
      {
        ...values,
        layoutHTML: data ? data : values.layoutHTML,
      },
      dispatch,
      state
    )
      .then((response) => {
        if (response.isSuccessfull) {
          setLoading(false);
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
            })
          );
          dispatch(
            setManageCommunicationToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
        } else {
          setLoading(false);
          for (var i = 0; i < response?.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch(() => setLoading(false));
  };
  const setEditor = (values) => {
    setData(values.layoutHTML);
    setShowEditor(true);
  };
  const openPage = (id) => {
    if (prevId.current === id) {
      setShowEditor(true);
      setShowLayout(false);
      return;
    }
    getEmailDataById(id).then((response) => {
      prevId.current = id;
      setData(response.layoutHTML);
      setShowEditor(true);
      setShowLayout(false);
    });
  };

  useDeepEffect(() => {
    if (isSave) setDirection("column");
  }, [flow]);
  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
          ...formValues,
        }}
        onSubmit={onFormSubmit}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          dirty,
          ...rest
        }) => {
          Dirty.current = dirty;
          return (
            <LoaderWrapper isLoading={loading} className="">
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <ManageCommunicationLayout
                  pageName={pageName.current}
                  buttons={buttons}
                  pageFlow={flow}
                  customBreadCrumbs={customBreadCrumbs}
                  blockNavigation={true}
                  buttonAlign={isEdit ? true : false}
                >
                  <div
                    className="NewEmailContainer"
                    style={{ display: "flex", flexDirection: `${direction}` }}
                  >
                    <div className="info">
                      <Field
                        size="md"
                        isRequired
                        name={fields.layoutName}
                        label={"E-Mail Layout Name"}
                        type="text"
                        autoComplete="off"
                        value={values[fields.layoutName]}
                        onChange={handleChange}
                        disabled={isEdit && !isSave}
                        component={FieldInput}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                          }
                        }}
                      />
                      <Field
                        name={fields.layoutDescription}
                        label="E-Mail Layout Description"
                        autoComplete="off"
                        value={values[fields.layoutDescription]}
                        onChange={handleChange}
                        disabled={isEdit && !isSave}
                        component={FieldTextarea}
                      />
                    </div>

                    {isEdit ? (
                      <div className="pic">
                        <p className="p1">Preview</p>
                        <p className="p2">{values?.layoutName}</p>
                        <div className="previewImage">
                          <img
                            src={values?.imagePath}
                            style={{
                              objectFit: "fill",
                              width: "100%",
                            }}
                          />
                        </div>
                      </div>
                    ) : isSave ? (
                      <>
                        <p className="pelement">E-Mail Layout</p>
                        <a href="#" onClick={() => setEditor(values)}>
                          {values?.layoutName}
                        </a>
                      </>
                    ) : null}
                  </div>
                  <SliderPanel isOpen={showEditor} size="74" showCancel={false}>
                    <div
                      className="mr-600"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <ManageCommunicationLayout
                        pageName="E-Mail Layout"
                        buttons={buttons1}
                        blockNavigation={true}
                      >
                        <div className="Container">
                          <QuillEditor
                            data={data}
                            setData={setData}
                            value={data}
                            isSubmit={isSubmit}
                            values={values}
                            name={fields.layoutHTML}
                          />
                        </div>
                      </ManageCommunicationLayout>
                    </div>
                  </SliderPanel>
                </ManageCommunicationLayout>
              </Form>
            </LoaderWrapper>
          );
        }}
      </Formik>
      {/* </LoaderWrapper> */}

      <SliderPanel
        backdropClicked={() => setShowLayout(false)}
        isOpen={showLayout}
        size="77"
        showCancel={false}
      >
        <div>
          <ManageCommunicationLayout
            pageName="Choose E-Mail Layout"
            buttons={buttons3}
            blockNavigation={true}
          >
            <div className="choose-layout">
              <div className="header1 slide-head">
                <p className="gr mb-6">Search</p>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text className="plan-search-button">
                      <Image src="/assets/icons/svg/search.svg" width="14px" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControlSearch
                    size="md"
                    type="search"
                    //className=" pad-left-search"
                    placeholder="Search E-Mail Layout"
                    onChange={(e) => {
                      const value = e?.target?.value;
                      append.current = false;
                      setRequest((prevRequest) => ({
                        ...prevRequest,
                        search: value,
                      }));
                    }}
                  />
                </InputGroup>
                {filteredImage && filteredImage.length !== 0 ? (
                  <div
                    // style={{ marginLeft: "305px" }}
                    className="header2-communication"
                  >
                    <p className="core-body-text-small-semi-bold">
                      {filteredImage.length} E-Mail Layouts found
                    </p>
                  </div>
                ) : null}
                <div style={{ overflowY: "scroll", maxHeight: "500px" }}>
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      append.current = true;
                      setRequest((prevRequest) => ({
                        ...prevRequest,
                        from: filteredImage?.length,
                      }));
                    }}
                    hasMore={!stopInfiniteScroll}
                    initialLoad={false}
                    //threshold={100}
                    useWindow={false}
                    loader={
                      <div className="loader" key={0}>
                        Loading ...
                      </div>
                    }
                  >
                    <div className="flex-wrap">
                      {filteredImage.length > 0 ? (
                        filteredImage.map((x, index) => {
                          return (
                            <Link
                              onClick={() => {
                                setSelectedImage(x);
                              }}
                              style={{ textDecoration: "none" }}
                            >
                              {" "}
                              <div className="mr-10">
                                <Image
                                  src={x.imagePath}
                                  className="img-border"
                                />
                                <p style={{ paddingBottom: "15px" }}>
                                  {x.layoutName.length > 15 ? (
                                    <AddToolTip
                                      className="link-text core-body-text-large-medium"
                                      name={x.layoutName}
                                      placement="bottom"
                                    >
                                      {(x.layoutName || "").slice(0, 15)}...
                                    </AddToolTip>
                                  ) : (
                                    <p className="link-text core-body-text-large-medium">
                                      {x.layoutName}
                                    </p>
                                  )}
                                </p>
                              </div>
                            </Link>
                          );
                        })
                      ) : (
                        <span
                          style={{
                            margin: "auto",
                            textAlign: "center",
                            fontSize: "18px",
                            color: "#333333",
                            paddingTop: "71px",
                          }}
                        >
                          No Records Found
                        </span>
                      )}
                    </div>
                  </InfiniteScroll>
                </div>
              </div>
              <div className="header2-right-communication">
                <div className="element1">
                  <div className="element2 core-heading-regular ">Preview</div>
                  {/* {selectedImage != null && (
                    <div>
                      <Button
                        variant="primary"
                        //onClick={() => openPage(filteredImage[selectedImage].id)}
                        onClick={() => openPage(selectedImage.id)}
                      >
                        Proceed
                      </Button>
                    </div>
                  )} */}
                </div>
                <div className="mt-30">
                  {selectedImage != null && (
                    <Image
                      src={selectedImage.imagePath}
                      width="550"
                      height="463"
                      className="img-border1"
                    />
                  )}
                </div>
              </div>
            </div>
          </ManageCommunicationLayout>
        </div>
      </SliderPanel>
      <FormLeaveGuard
        showModal={modalVisible}
        handleConfirmClick={() =>
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
            })
          )
        }
        handleCancelClick={() => setModalVisible(false)}
      />
      <WarningModal show={isDelete} onHide={() => setIsDelete(false)}>
        <div className="remove-text">
          <h4>Delete Email Layout ?</h4>
          <p>
            You are attempting to delete this Email layout . By deleting this ,
            associated communications will also become invalid . Do you still
            wish to delete?
          </p>
          <Button
            type="button"
            className="remove-btn mr-4 "
            onClick={() => {
              onDeleteClick();
              // history.push(
              //   getAdvancedPathWithParam({
              //     path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
              //   })
              // )
            }}
          >
            Delete
          </Button>
          <Button
            className="cancel-btn mr-4 "
            onClick={() => setIsDelete(false)}
          >
            No,Cancel
          </Button>
          {/* <Button className="cancel-btn" onClick={() => setIsDelete(false)}>
            No
          </Button> */}
        </div>
      </WarningModal>
      <WarningModal
        show={cannotBeDeleted}
        onHide={() => setCannotBeDeleted(false)}
      >
        <div className="remove-text">
          <h4>Communication configured to this Email Layout</h4>
          {/* <p>You are attempting to delete an Email layout that is already in use</p> */}
          <Button
            className="cancel-btn"
            onClick={() => setCannotBeDeleted(false)}
          >
            Ok
          </Button>
        </div>
      </WarningModal>
    </>
  );
};

export default NewEmailLayoutContainer;
